import { toast } from "sonner";
import api from "./api";

// Avvisa (senza bloccare) se il numero di sinistro è già usato in altre pratiche dello studio.
export async function warnDuplicateSinistro(num, excludeId) {
  const n = (num || "").trim();
  if (!n) return;
  try {
    const { data } = await api.get("/studio/sinistro-check", { params: { num: n, exclude: excludeId || "" } });
    if (data.matches?.length) {
      const list = data.matches.map((m) => m.numero_pratica || "senza numero").join(", ");
      toast.warning(`Attenzione: il numero di sinistro ${n} è già usato ${data.matches.length === 1 ? "nella pratica" : "nelle pratiche"} ${list}.`, { duration: 8000 });
    }
  } catch { /* controllo non bloccante */ }
}
